<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="epi">
<p class="ct"><a class="xref" href="#/OEBPS/ppprecoil007#toc">Epigraph</a></p>
<div class="epigraph">
<p class="epf">‘Revenge, at first though sweet,bitter ere long back on itself recoils.’</p>
<p class="ept">—John Milton</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-recoil006.vue?3954b94b